/* eslint-disable @typescript-eslint/consistent-type-definitions */
/* eslint-disable @typescript-eslint/no-namespace */
import {
  MenuBannerItem,
  SectionItem
} from '@britishgasenergy/react-nucleus/dist/nuc-components/NsxHeader/NsxHeader';
import {
  Primary,
  Link
} from '@britishgasenergy/react-nucleus/dist/nuc-components/NsHeader/NsHeader';

import { useSections } from 'components/common/nsx-header/hooks/useSections';
import { usePartner } from 'components/app/routes/usePartner';

// TODO: remove this once this is implmented in react-nucleus
interface NsHeaderAttributes extends React.HTMLAttributes<HTMLElement> {
  primary?: Primary[];
  secondary?: Link[];
  'secondary-banner'?: string;
  'menu-banner'?: MenuBannerItem[];
  'quick-links'?: string;
  'skip-subdomain'?: string;
  logo?: string;
  alt?: string;
  'hide-links'?: boolean;
  'no-root-link'?: boolean;
  type?: 'standard' | 'simple';
}

interface NsxHeaderAttributes extends React.HTMLAttributes<HTMLElement> {
  sections?: SectionItem[][];
  'secondary-banner'?: string;
  'menu-banner'?: MenuBannerItem[][];
  'quick-links'?: string;
  'hide-a11y-btn'?: boolean;
  type?: 'standard' | 'business';
}
declare module 'react' {
  namespace JSX {
    interface IntrinsicElements {
      'ns-header': React.DetailedHTMLProps<NsHeaderAttributes, HTMLElement>;
      'nsx-header': React.DetailedHTMLProps<NsxHeaderAttributes, HTMLElement>;
    }
  }
}

type Route = {
  name?: string;
};

type NsxHeaderProps = {
  route?: Route;
};

export const NsxHeader = ({ route }: NsxHeaderProps) => {
  const { partnerLogo } = usePartner();
  const {
    sections,
    menuBanner,
    secondaryBanner,
    nsxHeaderQuickLinks,
    primary,
    secondary,
    hideA11yBtn,
    nsHeaderQuickLinks
  } = useSections();

  // TODO: Change this to use react-nucleus verson once the nsx-header and ns-header is ready in react-nucleus - but with typescript it will not pass the build for now unknown way
  return partnerLogo ? (
    <ns-header
      logo={partnerLogo}
      alt={route?.name}
      primary={primary}
      secondary={secondary}
      quick-links={JSON.stringify(nsHeaderQuickLinks)}
      secondary-banner={JSON.stringify(secondaryBanner)}
      menu-banner={menuBanner}
    ></ns-header>
  ) : (
    <nsx-header
      menu-banner={menuBanner}
      secondary-banner={JSON.stringify(secondaryBanner)}
      quick-links={JSON.stringify(nsxHeaderQuickLinks)}
      sections={sections}
      hide-a11y-btn={hideA11yBtn}
    ></nsx-header>
  );
};
